var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesIssued(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_2ce6152f163e7522399fda577bea3d975c238aa1cc398cc547b612eb5aa37245",
    x1: 85.56,
    y1: 35,
    x2: 130.69,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_2ce6152f163e7522399fda577bea3d975c238aa1cc398cc547b612eb5aa37245",
    x1: 85.56,
    y1: 46.11,
    x2: 130.69,
    y2: 46.11,
    xlinkHref: "#SVGID_0_2ce6152f163e7522399fda577bea3d975c238aa1cc398cc547b612eb5aa37245"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_2ce6152f163e7522399fda577bea3d975c238aa1cc398cc547b612eb5aa37245",
    x1: 85.9,
    y1: 69.42,
    x2: 130.81,
    y2: 69.42,
    xlinkHref: "#SVGID_0_2ce6152f163e7522399fda577bea3d975c238aa1cc398cc547b612eb5aa37245"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M86.81 35h42.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.81 46.11h42.63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M68.2 45.68H50.5V29a8.86 8.86 0 0117.7 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M59.35 20.34h79.72a8.73 8.73 0 018.85 8.55V137H68.16V45.68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M108.51 59.48v60.22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_2_2ce6152f163e7522399fda577bea3d975c238aa1cc398cc547b612eb5aa37245)",
    d: "M87.15 69.42h42.41M87.15 79.85h42.41M87.15 90.27h42.41M87.15 100.37h42.41M87.15 109.98h42.41M86.97 59.26h42.59v60.77H86.97z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIssued);
export default __webpack_public_path__ + "static/media/invoicesIssued.529c5be7a9412211ee65aeb799b28920.svg";
export { ForwardRef as ReactComponent };